import { BASE_URL } from '../const';
import { mogamboRequestV2 } from './utils';

export const getStory = async domainId => {
  const url = `${BASE_URL}/story/?domain_id=${domainId}`;
  const response = await mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const updateStory = async (storyId, data, additionalHeaders) => {
  const url = `${BASE_URL}/story/${storyId}`;
  const response = mogamboRequestV2(
    url,
    'POST',
    data,
    undefined,
    additionalHeaders
  );
  return Promise.resolve(response);
};
